import React from 'react';
import { Card, CardTitle } from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import { Link } from 'react-router-dom';
import 'pure-react-carousel/dist/react-carousel.es.css';
import { getReasonToChooseUs, getHowItWorks } from '../constants/common'
import {TEXT_COLOR, BUTTON_COLOR } from '../constants/colours'
import Slider from "react-slick";
import language from '../constants/languages'
import { isEmpty } from 'lodash'

const mainImg = 'images/main_image.jpg'
const slider1 = 'images/slider-1.jpg'
const slider2 = 'images/slider-2.jpg'
const slider3 = 'images/slider-3.jpg'
const slider4 = 'images/slider-4.jpg'
const slider5 = 'images/slider-5.jpg'

const styles = {
  mainDiv: {
    fontFamily: 'Open Sans',
  },
	appBar: {
    padding: 20,
		backgroundColor: '#095390',
    flexWrap: 'wrap',
		color: 'white'
	},
	buttonStyle: {
    borderColor: 'white',
    marginTop: '25px',
		marginBottom: '10px'
	},
	card: {
    textAlign: 'center',
    margin: 25,
	},
  imgStyle: {
  	paddingTop: 10,
	  height: '50px',
    width: 'auto'
  },
  textSize: {
	  fontSize : 18,
    fontWeight: 600
  }
};

const homeImageSlider = {
	infinite: true,
	speed: 300,
	slidesToShow: 1,
	slidesToScroll: 1,
	autoplay: true,
	arrows: false,
	dots: true,
	pauseOnHover: true,
	initialSlide: 0,
  lazyLoad: 'onDemand',
	responsive: [
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 1
			}
		}
	]
}

const Home = props => (
  !isEmpty(props.selectedLanguage) && <div style={styles.mainDiv}>
    <Card>
      <div className="container">
	      <Slider {...homeImageSlider}>
		      <img src={slider1}/>
		      <img src={slider2}/>
		      <img src={slider3}/>
		      <img src={slider4}/>
		      <img src={slider5}/>
	      </Slider>
      </div>
	    <div style={{textAlign: 'center', fontSize: 13, textColor: TEXT_COLOR}}>
	     <div className="custom-h2">{language[props.selectedLanguage].tagline1}</div>
	     <div className="custom-h3">{language[props.selectedLanguage].tagline2}</div>
	     <RaisedButton
	     backgroundColor={BUTTON_COLOR}
	     containerElement={<Link to="/apply" />}
	     label={language[props.selectedLanguage].apply}
	     labelColor="white"
	     style={styles.buttonStyle}
	     />
	     </div>
    </Card>
    <Card style={{justifyContent: 'space-around', backgroundColor: '#efefef', marginTop: 10}}>
	    <CardTitle style={{textAlign: 'center'}} title={<span className="underline">{language[props.selectedLanguage].reasons_to_choose}</span>} />
      <div id="wrapper" style={{paddingBottom: 10, justifyContent: 'space-around'}}>
        {
					getReasonToChooseUs(props.selectedLanguage).map((val, index)=> {
	          return (<div key={index} className="on_hover_white border_box" style={styles.card}>
              <img src={val.imageSrc} style={styles.imgStyle}/>
              <div className="header">{val.header}</div>
              <p style={{paddingBottom: 10}}>{val.content}</p>
            </div>)
          })
        }
      </div>
    </Card>
	  <div id="howItWorksId"></div>
    <Card style={{justifyContent: 'space-around', marginTop: 10}}>
      <CardTitle style={{textAlign: 'center'}} title={<span className="underline">{language[props.selectedLanguage].how_it_works}</span>} />
      <div id="wrapper" style={{paddingBottom: 10, justifyContent: 'space-around'}}>
	      {
					getHowItWorks(props.selectedLanguage).map((val, index)=> {
			      return (<div key={index} className="on_hover border_box_white" style={styles.card}>
              <img src={val.imageSrc} style={styles.imgStyle}/>
              <div className="header">{val.header}</div>
              <p style={{paddingBottom: 10}}>{val.content}</p>
            </div>)
		      })
	      }
      </div>
    </Card>
    </div>
);

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js